define([
    'text!index2021-cooperate/component/item-grocery.html',
    'index2021-cooperate/mixin/form'
], function(
    tpl,
    FormMixin
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 3,
                    companyName: '',
                    contact: '',
                    tel: '',
                    companyInfo: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/component/item-grocery.js
// module id = 235
// module chunks = 0